export default __webpack_public_path__ + "static/5-9903a05d826972b286c24e76babef872.png";